import TableSimple from "./TableSimple";
import RetentionsTable from './RetentionsTable'
import TicketsTable from './TicketsTable'

export { TableSimple, RetentionsTable, TicketsTable }